/**
 * #253: the registry of suspense caches, kept deliberately free of any import.
 *
 * The error boundary needs to forget cached reads when the reader asks to try
 * again — but the boundary is loaded eagerly by the router, and importing
 * `services/data` from it would drag the whole Firestore layer into the main
 * bundle along with it. This module is the seam: `data.js` registers its caches
 * here, and the boundary depends only on this file.
 */
const caches = []

export const registerCache = (cache = {}) => {
  caches.push(cache)
  return cache
}

/**
 * Forget every cached read. Without it a retry re-renders into the identical
 * cached answer — including a read that succeeded and returned a document that
 * does not exist, which is what made the error screen unrecoverable.
 */
export function clearDataCaches() {
  caches.forEach(cache => {
    Object.keys(cache).forEach(key => { delete cache[key] })
  })
}
